/**
 * Generated by orval v7.21.0 🍺
 * Do not edit manually.
 * Arrayscape Gaming Dashboard API
 * Comprehensive REST API for event management, business operations, and analytics
 * OpenAPI spec version: 1.0.0
 */

export type GetReportsBurnRateParamsGroupBy = typeof GetReportsBurnRateParamsGroupBy[keyof typeof GetReportsBurnRateParamsGroupBy];


// eslint-disable-next-line @typescript-eslint/no-redeclare
export const GetReportsBurnRateParamsGroupBy = {
  GetReportsBurnRateParamsGroupByDay: 'day',
  GetReportsBurnRateParamsGroupByMonth: 'month',
  GetReportsBurnRateParamsGroupByQuarter: 'quarter',
  GetReportsBurnRateParamsGroupByWeek: 'week',
  GetReportsBurnRateParamsGroupByYear: 'year',
} as const;
